"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
require("../styles/Table.css");
var _dist = require("package_ui_ihm/dist");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : TableStatus.js
* Description : Ce fichier contient la définition du composant TableStatus
*               Ce composant est un tableau sans bordure pour afficher le status d'un essai 
*               (label, valeur et icône de couleur) en colonne
* Date de création : 19 novembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* TableStatus : ce composant est un tableau sans bordure pour afficher le status d'un essai 
*               (label, valeur et icône de couleur) en colonne
*
* Type : composant 
*
* Parametres : 
*  - label -- label à afficher
*  - status -- texte du status
*  - color -- couleur du status
*/function TableStatus(_ref) {
  var label = _ref.label,
    status = _ref.status,
    color = _ref.color;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: screenWidth > 650 ? 'grid-1-1-2' : 'grid-1-1',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
        className: "table-cell table-label",
        children: [label, " :"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-row",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "table-cell table-data",
        children: status
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.IconStatus, {
        color: color
      })]
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
TableStatus.propTypes = {
  label: _propTypes["default"].string,
  status: _propTypes["default"].string,
  color: _propTypes["default"].string
};
var _default = exports["default"] = TableStatus;